module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_7005.941b4c92.png";